import { Component, inject, Input, OnDestroy } from '@angular/core';
import {
  IxFavoriteListComponent,
  IxNgHtmlStaticUtils,
  IxNgHtmlUtilsService,
  IxUiHeightServiceImpl,
} from 'ix-ng-components';
import { IxUiHeightService } from 'ix-ng-core';
import { Language } from 'projects/vpo-shared/src/vpoglednik/vpoglednik.enum';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { PostavitevInfoComponent } from 'projects/vpo-shared/src/lib/postavitev/postavitev-info.component';
import { NgOptimizedImage } from '@angular/common';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['topbar.component.scss'],
  providers: [{ provide: IxUiHeightService, useClass: IxUiHeightServiceImpl }],
  imports: [PostavitevInfoComponent, NgOptimizedImage],
})
export class TopbarComponent implements OnDestroy {
  @Input()
  public admin = false;
  public soSistemske = false;
  public nazivAplikacije = 'VPOGLEDNIK';
  private subscription: Subscription;

  public ixNgHtmlUtilsService = inject(IxNgHtmlUtilsService);
  private router = inject(Router);

  constructor() {
    IxFavoriteListComponent.showCloseIcon = true;
    this.subscription = this.router.events.subscribe((val) => {
      // ob spremembi strani nastavimo leto in jezik
      if (val instanceof NavigationEnd) {
        const segments = location.href.split('/');
        this.soSistemske = segments[segments.length - 1] === 'sistemskeNastavitve';

        if (
          segments.length > 1 &&
          !['sistemskeNastavitve', '404'].includes(segments[segments.length - 1])
        ) {
          const leto = segments[segments.length - 2];
          const regex = /^-1$|^(20\d{2}|2100)$/;

          if (regex.test(leto)) {
            const jezik = segments[segments.length - 1];
            this.nazivAplikacije =
              (jezik === Language.EN
                ? 'Recipients of funds in year '
                : 'Prejemniki sredstev za leto ') + leto;
            return;
          }
        }
        this.nazivAplikacije = 'VPOGLEDNIK';
      }
    });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  protected readonly IxNgHtmlStaticUtils = IxNgHtmlStaticUtils;
}
